import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import hadiyaLogo from '../assets/hadiya-logo-web.png';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem('admin_user');
    if (userData) {
      try {
        setUser(JSON.parse(userData));
      } catch (e) {
        console.error('Invalid user data');
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    navigate('/react-user/login');
  };

  if (!user) return null;

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.logoAndUserGroup}>
            <img src={hadiyaLogo} alt="Hadiya Logo" style={styles.headerLogo} />
            <div style={styles.userInfo}>
              <h2 style={styles.userName}>{user.name}</h2>
              <span style={styles.userRole}>{user.type.toUpperCase()}</span>
            </div>
          </div>
          <button onClick={handleLogout} style={styles.logoutBtn}>Logout</button>
        </div>
      </header>

      <main style={styles.main}>
        
        <div style={styles.grid}>
          {/* Suffa Dars Card */}
          <div style={styles.card} onClick={() => navigate('/suffa_dars/admin')}>
            <h3 style={styles.cardTitle}>Suffa Student Details</h3>
            <div style={styles.cardAction}>Go to Suffa Dars →</div>
          </div>

          {/* Exams Analytics Card - Only visible to Admins (level >= 80) */}
          {user.level >= 80 && (
            <div style={styles.card} onClick={() => navigate('/exam/analytics')}>
              <h3 style={styles.cardTitle}>Live Exam Analytics</h3>
              <p style={styles.cardDesc}>Monitor ongoing online exams, track active students, and view real-time stats.</p>
              <div style={styles.cardAction}>Go to Analytics →</div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f8fafc',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  header: {
    background: '#ffffff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    padding: '16px 32px',
  },
  headerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logoAndUserGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
  },
  headerLogo: {
    height: '40px',
    objectFit: 'contain',
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  userName: {
    margin: '0 0 4px',
    fontSize: '18px',
    color: '#1e293b',
  },
  userRole: {
    fontSize: '12px',
    color: '#64748b',
    background: '#f1f5f9',
    padding: '2px 8px',
    borderRadius: '12px',
    fontWeight: '600',
  },
  logoutBtn: {
    background: 'none',
    border: '1px solid #e2e8f0',
    padding: '8px 16px',
    borderRadius: '6px',
    color: '#64748b',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'all 0.2s',
  },
  main: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '48px 32px',
  },
  pageTitle: {
    margin: '0 0 32px',
    fontSize: '28px',
    color: '#0f172a',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
    gap: '24px',
  },
  card: {
    background: '#ffffff',
    padding: '32px',
    borderRadius: '16px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    border: '1px solid #f1f5f9',
  },
  iconWrapper: {
    width: '64px',
    height: '64px',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '24px',
  },
  cardTitle: {
    margin: '0 0 12px',
    fontSize: '20px',
    color: '#1e293b',
  },
  cardDesc: {
    margin: '0 0 24px',
    fontSize: '15px',
    color: '#64748b',
    lineHeight: '1.5',
  },
  cardAction: {
    color: '#3b82f6',
    fontWeight: '600',
    fontSize: '15px',
  },
};
